import React from 'react';
import { formatText } from 'core/i18n';

export const ButtonPrevSpecial = ({ buttonPrevAction, buttonPrevSpecialHidden }) => {
    const buttonClass = buttonPrevSpecialHidden
        ? 'hidden'
        : 'form__button form__button-negative roadmap-navigation__button-prev';

    return (
        <button className={buttonClass} type="button" onClick={buttonPrevAction} data-testid="button-prev-special">
            {formatText('button-prev')}
        </button>
    );
};
